module.exports = __webpack_public_path__ + "img/cases-brand-herborist-5.a53b0b58.jpg";